import { Image } from 'expo-image';

export const ConfirmHeaderOverlay = () => (
  <Image
    source={require('./order-confirm-details-header-overlay.webp')}
    style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0 }}
  />
);
